import { useEffect } from 'react';
import TestimonialsHero from "./components/TestimonialsHero";
import OurJourney from "./components/OurJourney";
import TrainingGallery from "./components/TrainingGallery";
import AwardsRecognition from "./components/AwardsRecognition";
import CorporateTestimonials from "./components/CorporateTestimonials";

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function Testimonials() {
  useEffect(() => {
    document.title = 'Testimonials & Success Stories | STEMForge Tech Labs | School STEM Impact';

    const setMeta = (name: string, content: string, attr = 'name') => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Read real success stories and testimonials from schools transformed by STEMForge Tech Labs. Discover our journey, awards, and the impact of our STEM education programs.');
    setMeta('keywords', 'STEMForge testimonials, school STEM success stories, STEM education impact, awards recognition, corporate testimonials');
    setMeta('robots', 'index, follow');
    setMeta('og:title', 'Testimonials & Success Stories | STEMForge Tech Labs', 'property');
    setMeta('og:description', 'Read real success stories and testimonials from schools transformed by STEMForge Tech Labs. Discover our journey, awards, and the impact of our STEM education programs.', 'property');
    setMeta('og:url', `${SITE_URL}/testimonials`, 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('twitter:title', 'Testimonials & Success Stories | STEMForge Tech Labs');
    setMeta('twitter:description', 'Read real success stories and testimonials from schools transformed by STEMForge Tech Labs.');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${SITE_URL}/testimonials`;

    const schemaId = 'schema-testimonials';
    let script = document.getElementById(schemaId);
    if (!script) {
      script = document.createElement('script');
      script.id = schemaId;
      (script as HTMLScriptElement).type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${SITE_URL}/testimonials`,
      url: `${SITE_URL}/testimonials`,
      name: 'Testimonials & Success Stories | STEMForge Tech Labs',
      description: 'Read real success stories and testimonials from schools transformed by STEMForge Tech Labs. Discover our journey, awards, and the impact of our STEM education programs.',
      dateModified: '2026-04-10',
      isPartOf: { '@type': 'WebSite', url: SITE_URL, name: 'STEMForge Tech Labs' },
      mainEntity: {
        '@type': 'ItemList',
        name: 'STEMForge Testimonials',
        description: 'Success stories and testimonials from schools and corporates partnered with STEMForge Tech Labs.',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            item: {
              '@type': 'Review',
              name: 'School STEM Transformation',
              reviewBody: 'STEMForge transformed our school\'s approach to STEM education with hands-on labs and expert teacher training.',
              author: { '@type': 'Organization', name: 'Partner School' },
              itemReviewed: { '@type': 'Organization', name: 'STEMForge Tech Labs' },
            },
          },
        ],
      },
    });

    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <main className="min-h-screen bg-white">
      <TestimonialsHero />
      <OurJourney />
      <TrainingGallery />
      <AwardsRecognition />
      <CorporateTestimonials />
    </main>
  );
}
